import './Content.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ContentDefaultProps, ContentPropTypes } from './Content.proptypes';

const Content = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('scanbat-no-cart-content', className)}>
      <div className="scanbat-no-cart-content__error error">
        {t('ebat:entities:scanbat.no_cart.error')}
      </div>
    </div>
  );
};

Content.defaultProps = {
  ...ContentDefaultProps,
};

Content.propTypes = {
  ...ContentPropTypes,
};

export default Content;
